const Close = () => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.33317 11.8334L0.166504 10.6667L4.83317 6.00008L0.166504 1.33341L1.33317 0.166748L5.99984 4.83341L10.6665 0.166748L11.8332 1.33341L7.1665 6.00008L11.8332 10.6667L10.6665 11.8334L5.99984 7.16675L1.33317 11.8334Z"
        fill="#6E6E6E"
      />
    </svg>
  );
};

export default Close;
